import { DESKTOP_MIN_WIDTH } from 'src/constants/dimensions';
export const PHONE_MAX_WIDTH = 600;
/**
 * Maps a single width value to a device bucket.
 * - phone:   < 600
 * - tablet:  600 - 1023
 * - desktop: >= 1024 (DESKTOP_MIN_WIDTH)
 */
export function getDeviceType(width) {
    return {
        isPhone: width < PHONE_MAX_WIDTH,
        isTablet: width >= PHONE_MAX_WIDTH && width < DESKTOP_MIN_WIDTH,
        isDesktop: width >= DESKTOP_MIN_WIDTH,
    };
}
